import React, { useState } from "react";
import {
  GoogleMap,
  withGoogleMap,
  Marker,
  InfoWindow,
} from "react-google-maps";
import { useNavigate } from "react-router";
import markerIcon from "../../../images/marker.png";
import { Marker as Marcador } from "../../../utils/entities/Marker";

const NormalMap = 
  withGoogleMap((props: any) => {
    const marks = props.markers;
    const navigate = useNavigate();
    const goToOportunity = () => {
      navigate(`/oportunidad/${markerSelected.ongId}/${markerSelected.id}`);
    };
    const [markerSelected, setMarkerSelected] = useState<Marcador>(
      {} as Marcador
    );

    const handleClick = (currentMarker: any) => {
      setMarkerSelected(currentMarker);
    };

    return (
      <GoogleMap defaultOptions={{
          center:{
            lat: -34.8833,
            lng: -56.1667,
          },
          gestureHandling: "greedy",
          disableDefaultUI: true,
          zoom: 12,
          minZoom: 8,
          maxZoom: 15,
          streetViewControl: false,
          rotateControl: false,
          panControl: false,
          mapTypeControl: false,
        }}
      >
        {marks?.map((marker: Marcador, i: number) => {
          return (
            <Marker
              icon={markerIcon}
              position={{
                lat: marker.coords.x,
                lng: marker.coords.y,
              }}
              onClick={() => {
                //setIsOpened(false)
                handleClick(marker);
              }}
              key={i}
              title={marker.name}
            >
              {markerSelected === marker && (
                //<Bubble marker={markerSelected} handleClickFn= {handleClick} />
                <InfoWindow
                  onCloseClick={() => {
                    handleClick(null);
                  }}
                >
                  <div className="dialog-content">
                    <div className="titulo">{markerSelected.name}</div>
                    <div className="descripcion">{markerSelected.description}</div>
                    <div className="button-row">
                      <button
                        onClick={() => {goToOportunity()}}
                        type="button"
                        className="ant-btn ant-btn-primary ir-a-donacion"
                      >
                        <span>Ver más</span>
                      </button>
                    </div>
                  </div>                  
                </InfoWindow>
              )}
            </Marker>
          );
        })}
      </GoogleMap>
    );
  })


export default NormalMap;
